<style lang="scss" scoped>
    .char-count {
        color: black;
        font-weight: normal;
        font-size: 0.9em;
    }

    .form-group label {
        color: #4d8ab7;
        font-size: 17px;
        font-weight: 700;
    }
</style>

<template>
    <div>
        <p>Please enter a name for your training session. The name should be unique (examples: Martha A. Infant Classroom, Little Lambs Morning Session). This will help you find and print training certificates once the training is complete.</p>
        <div class="container">
            <div class='form-group col align-items-center'>
                <label class="col">Session Name: <br /><span class="char-count">(Max {{ maxSessionTitleLength }} characters. {{ maxSessionTitleLength - sessionTitle.length }} remaining)</span></label>
                <input type="text" class="session-title col" ref="sessionTitle" v-model="sessionTitle" @input="clearValidation($event)" :maxlength="maxSessionTitleLength"/>
            </div>
            <div class='form-group col align-items-center'>
                <label class="col" for="session-date">Time: </label>
                <input type="datetime-local" value="01/01/2025" name="session-date" class="session-date col" ref="sessionDate" v-model="sessionDate" required></input>
            </div>
            <div>
                <button type="button" @click="submitNewSession" class="btn bg-orange text-white float-right"><span v-html="submitTemplate"></span></button>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapMutations } from 'vuex';

    export default{
        components: {
        },
        props: {
            trainingId: {
                default: 0,
                required: true
            },
            newSession: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                sessionTitle: "",
                sessionDate: null,
                loading: false,
            }
        },
        methods: {
            submitNewSession() {
                if(!this.validate()) {
                    return;
                };

                this.loading = true;
                let vm = this;

                let data = {
                    title: this.sessionTitle ? this.sessionTitle : "Session on " + moment(this.sessionDate).format('MM/DD/YY'),
                    start_time: this.sessionDate
                };

                axios.post('provider-trainings/' + this.trainingId + '/training-session', data)
                .then(response => {
                    let trainingSession = response.data.trainingSession;
                    vm.addSession({
                        trainingId: this.trainingId,
                        trainingSessionId: trainingSession.id, 
                        trainingSession,
                        isNew: true
                    });

                    this.setShowAddTrainingSession({setShowAddTrainingSession: false});
                    this.setCurrentTrainingSession({currentTrainingSession: trainingSession});

                    // this.$emit('add-new-session');
                });
            },
            validate() {
                if(!this.sessionTitle) {
                    this.$refs.sessionTitle.setCustomValidity("Please enter a name for your training session.");
                    this.$refs.sessionTitle.reportValidity();
                    return false;
                }

                if(!this.sessionDate) {
                    this.$refs.sessionDate.setCustomValidity("Please select a date and time for this session.");
                    this.$refs.sessionDate.reportValidity();
                    return false;
                }

                this.$refs.sessionTitle.setCustomValidity("");
                this.$refs.sessionDate.setCustomValidity("");
                this.$refs.sessionDate.reportValidity();

                return true;
            },
            // clear validation message on element on user input
            clearValidation(event) {
                event.target.setCustomValidity("")
            },
            ...mapMutations({
                addSession: 'ADD_NEW_SESSION',
                setShowAddTrainingSession: 'SET_SHOW_ADD_TRAINING_SESSION',
                setCurrentTrainingSession: 'SET_CURRENT_TRAINING_SESSION',
            })
        },
        computed: {
            submitTemplate() {
                if(this.loading) {
                    return "<i class='fa fa-spin fa-spinner' aria-hidden='true'></i>";
                }
                return "Submit";
            },
            maxSessionTitleLength() {
                return 150;
            }
        },
        watch: {
            newSession: {
                immediate: true,
                handler: function(newVal, oldVal) {
                    if(newVal) {
                        this.sessionTitle = "";
                        this.sessionDate = null;
                        this.loading = false;
                    }
                }
            }
        }
    }
</script>
